var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoirYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8872 12.0439L11.3872 14.0439V10.0439L14.8872 12.0439Z",
    fill: "#375DBB",
    stroke: "#375DBB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88721 12.7508V11.3358C2.88721 8.44085 2.88721 6.99285 3.79221 6.06185C4.69821 5.12985 6.12421 5.08985 8.97521 5.00885C10.3252 4.97085 11.7052 4.94385 12.8872 4.94385C14.0682 4.94385 15.4482 4.97085 16.7992 5.00885C19.6502 5.08985 21.0762 5.12985 21.9812 6.06185C22.8872 6.99285 22.8872 8.44185 22.8872 11.3358V12.7508C22.8872 15.6468 22.8872 17.0938 21.9822 18.0258C21.0762 18.9568 19.6512 18.9978 16.7992 19.0778C15.4492 19.1168 14.0692 19.1438 12.8872 19.1438C11.583 19.1399 10.2788 19.1179 8.97521 19.0778C6.12421 18.9978 4.69821 18.9578 3.79221 18.0258C2.88721 17.0938 2.88721 15.6458 2.88721 12.7518V12.7508Z",
    stroke: "#375DBB",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirYoutube);
export default __webpack_public_path__ + "static/media/iconoir_youtube.209b6b5556bd21e8ec0c361a028069e8.svg";
export { ForwardRef as ReactComponent };